import styled from 'styled-components';

const TeachersContainer = styled.article`
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	${props => props.theme.breakpoints.up('xs')} {
		padding: 8% 12% 15% 12%;
	}
	${props => props.theme.breakpoints.up('sm')} {
		padding: 0% 7% 1% 7%;
	}
`;

export default TeachersContainer;
